import RegistrationHandler from "../../services/api/registrationHandler";
import CallManagerHandler from "../../services/api/callManagerHandler";
import AvailableStatus from "../../components/atoms/Status/AvailableStatus";
import UnavailableStatus from "../../components/atoms/Status/UnavailableStatus";
import UnreachableStatus from "../../components/atoms/Status/UnreachableStatus";
import WrapupStatus from "../../components/atoms/Status/WrapupStatus";
import LocationHandler from "../../services/api/locationHandler";
import CustomValueHandler from "../../services/api/customValuesHandler";

/**
 * This controller handles all the business logic related to the main app ie. call assistant
 *
 */

export function setRegistrationStatus(value) {
  return RegistrationHandler.setRegistrationStatus(value)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.warn("Error setting registered...");
      throw (err);
    });
}

export function setTeamRegistrationStatus(id, status, permissionStore) {
  if (!permissionStore.havePermissions("Call Manager", ["TeamReg"]))
    return Promise.reject(new Error("No permissions for team reg"));

  return CallManagerHandler.setTeamRegistrationStatus(id, status)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.warn("Error setting team registration status...");
      throw (err);
    });
}

export function setRegisteredNumber(value) {
  return RegistrationHandler.setRegisteredNumber(value)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.warn("Error setting registered number...");
      throw (err);
    });
}

export function setStatusCode(statusCode) {
  return CallManagerHandler.setStatusCode(statusCode)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.warn("Error setting status code...");
      throw (err);
    });
}

export function setReasonCode(reasonCode) {
  return CallManagerHandler.setReasonCode(reasonCode)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.warn("Error setting reason code...");
      throw (err);
    });
}

export function setLocationCode(locationCode) {
  return LocationHandler.setLocationCode(locationCode)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.warn("Error setting location code...");
      throw (err);
    });
}

export function getStatusDropdownItems(statusCodes, reasonCodes, loggedIntoTeam) {
  let items = [];

  for (let statusCode of statusCodes) {
    let item = {
      statusCode: statusCode.code,
      text: statusCode.description,
      icon: getStatusIcon(statusCode.code),
      selectable: getStatusSelectable(statusCode, loggedIntoTeam),
    };

    items.push(item);

    // if not ready, get reason code description too
    if (statusCode.code === 4) {
      for (let reasonCode of reasonCodes) {
        item = {
          statusCode: statusCode.code,
          reasonCode: reasonCode.code,
          text: statusCode.description + " (" + reasonCode.description + ")",
          icon: UnavailableStatus,
          selectable: statusCode.agentSelectable,
        };

        items.push(item);
      }
    }
  }
  return items;
}

export const getStatusIcon = (code) => {
  switch (code) {
    case 3: // wrap up
      return WrapupStatus;
    case 6: // unreachable
      return UnreachableStatus;
    case 1: // ready
      return AvailableStatus;
    default:
      // everything else is unavailable
      return UnavailableStatus;
  }
};

export const getStatusSelectable = (statusCode, loggedIntoTeam) => {
  let selectable = statusCode.agentSelectable;

  if (statusCode.code === 4) {
    // Not ready
    selectable = false;
  } else if (statusCode.code === 1) {
    // ready
    selectable = loggedIntoTeam;
  }

  return selectable;
};

export const setCustomValue = (key, value, permissionStore) => {
  if (!permissionStore.havePermissions("Custom Values", ["Set"])) {
    // resolve the promise as this is ok to fail
    return Promise.resolve(null);
  }

  return CustomValueHandler.setCustomValue(key, value)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.warn("Error setting custom value...");
      throw (err);
    });
};

export const getShowWelcomeDialog = (key, permissionStore) => {
  
  if (!permissionStore.havePermissions("Custom Values", ["Get", "Set"])) {
    return Promise.resolve(false);
  }

  // we have the permissions so fire the promise chain
  return CustomValueHandler.getCustomValue(key)
    .then((response) => {
      let shouldShow = true;
      if (response && response.value === "true") {
        shouldShow = false;
      }
      return shouldShow;
    })
    .catch((err) => {
      // never skipped welcome returns 404 so show welcome screen
      if (err.response && err.response.status === 404) {
        return true;
      }
      console.warn("Error getting custom value...");
      return false;
    });
};
